import { useMutation } from '@tanstack/react-query';

import { AccessRequestsApiCreateUserAccessRequestRequest } from '../../api/v1';

import useAccessRequestsApi from './use-access-requests-api';

export default function useCreateUserAccessRequest() {
  const api = useAccessRequestsApi();

  const {
    mutate: createUserAccessRequest,
    mutateAsync: createUserAccessRequestAsync,
    ...rest
  } = useMutation(async (payload: AccessRequestsApiCreateUserAccessRequestRequest) => {
    const res = await api.createUserAccessRequest(payload);
    return res;
  });

  return {
    createUserAccessRequest,
    createUserAccessRequestAsync,
    ...rest,
  };
}
